import { nuevoIdSolicitud, textoError } from "../Utilitario/catalogo";

export default {
  computed: {
    viajeCaliente() {
      return (this.caliente.solicitud ? this.caliente.solicitud.numeroViaje : this.turno.id ? this.turno.numeroViaje : "") || "";
    },
    productoCaliente() { return this.caliente.productos.find(p => String(p.codigo) === String(this.caliente.productoId)); },
    impuestoCaliente() {
      const monto = Number(this.caliente.monto || 0), tasa = Number((this.productoCaliente || {}).tasa || 0);
      return Math.round((monto - Math.round(monto / (1 + tasa / 100) * 100) / 100) * 100) / 100;
    },
  },
  methods: {
    claveCaliente() {
      const h = this.headers();
      return "transporte.caliente:" + JSON.stringify([h["X-TENANT-ID"], h.usuario || h.AutUser,
        this.contexto.cajaId || this.contexto.caja]);
    },
    persistirCaliente() {
      // Persist before POST: reloading/retrying must use the same request identity.
      sessionStorage.setItem(this.claveCaliente(), JSON.stringify(this.caliente));
    },
    limpiarCalienteConfirmada() {
      sessionStorage.removeItem(this.claveCaliente());
      this.caliente = this.nuevaVentaCaliente();
      this.limpiarVenta();
    },
    async abrirVentaCaliente() {
      if (this.guardando || this.creandoTurno || this.caliente.cargando || this.caliente.solicitud) return;
      try {
        const pendiente = JSON.parse(sessionStorage.getItem(this.claveCaliente()) || "null");
        if (pendiente && pendiente.solicitud) {
          this.limpiarVenta();
          this.caliente = { ...this.nuevaVentaCaliente(), ...pendiente, activo: true, visible: false, cargando: false };
          this.pagos = { ...this.nuevosPagos(), ...pendiente.solicitud.pagosPantalla };
          this.comprobante = this.nuevoComprobante();
          this.editarFiscal = false;
          this.mostrarMensaje("Venta caliente pendiente de confirmar. Pulse FIN para recuperar la misma factura.", "warning");
          return;
        }
      } catch (_) {
        this.mostrarMensaje("No se pudo leer la venta pendiente del navegador. No inicie otra venta caliente hasta revisar el almacenamiento.", "error");
        return;
      }
      if (!(this.contexto.cajaId || this.contexto.caja)) {
        this.mostrarMensaje("Seleccione una caja antes de vender Guagua caliente.", "error");
        return;
      }
      if (!this.caliente.activo && (this.rutaSeleccionada || this.totalPagado > 0)
          && !window.confirm("Se limpiara la venta de boletos en preparacion. Desea continuar con Guagua caliente?")) return;
      const actual = this.caliente;
      actual.anterior = actual.activo ? { productoId: actual.productoId, monto: actual.monto,
        vehiculoId: actual.vehiculoId, unidad: actual.unidad } : null;
      actual.visible = true; actual.cargando = true; actual.error = "";
      try {
        const r = await this.$axios.get(this.$hostname + this.$hName + "/transportepv/calientes", {
          headers: this.headers(), params: this.turno.id ? { turnoId: this.turno.id } : {}, timeout: 30000,
        });
        actual.productos = r.data.productos || [];
        actual.unidades = r.data.unidades || [];
        if (!actual.activo && actual.vehiculoId == null) actual.vehiculoId = r.data.unidad ? r.data.unidad.id : null;
        this.seleccionarFichaCaliente();
        if (!actual.unidades.length) actual.error = "No hay fichas activas con propietario disponibles para facturar.";
        if (!actual.productos.length) actual.error = "No hay productos activos marcados Guagua caliente en Inventario.";
        if (!actual.productos.some(p => String(p.codigo) === String(actual.productoId)))
          actual.productoId = actual.productos.length === 1 ? actual.productos[0].codigo : null;
      } catch (error) { actual.unidades = []; actual.unidad = null; actual.vehiculoId = null; actual.error = textoError(error); }
      finally { actual.cargando = false; }
    },
    textoFichaCaliente(unidad) {
      if (!unidad) return "";
      return [unidad.ficha, unidad.propietario].map(v => v == null ? "" : String(v).trim()).filter(Boolean).join(" - ");
    },
    seleccionarFichaCaliente() {
      const c = this.caliente;
      c.unidad = c.unidades.find(u => String(u.id) === String(c.vehiculoId)) || null;
      if (!c.unidad) c.vehiculoId = null;
    },
    aceptarVentaCaliente() {
      const c = this.caliente;
      if (c.cargando || c.solicitud) return;
      this.seleccionarFichaCaliente();
      if (!c.unidad) { c.error = "Seleccione la ficha a la que se facturara la Guagua caliente."; return; }
      if (!this.productoCaliente || !c.unidad || !Number.isFinite(Number(c.monto)) || Number(c.monto) <= 0
          || Math.abs(Number(c.monto) * 100 - Math.round(Number(c.monto) * 100)) > 0.000001) {
        c.error = "Seleccione el producto e indique un monto mayor que cero, con hasta dos decimales."; return;
      }
      this.limpiarVenta();
      this.caliente = { ...c, activo: true, visible: false, error: "" };
      this.mostrarMensaje("", "");
      this.enfocarCampoBoleto("boletoEfectivo");
    },
    cancelarDialogoCaliente() {
      if (this.caliente.cargando) return;
      this.caliente.visible = false;
      if (this.caliente.anterior) Object.assign(this.caliente, this.caliente.anterior);
      if (!this.caliente.activo) this.caliente = this.nuevaVentaCaliente();
    },
    async finalizarCaliente() {
      if (this.guardando || this.caliente.visible) return;
      const c = this.caliente;
      if (!c.solicitud) {
        if (!(this.contexto.cajaId || this.contexto.caja)) {
          this.mostrarMensaje("Seleccione una caja antes de vender Guagua caliente.", "error"); return;
        }
        this.seleccionarFichaCaliente();
        if (!c.unidad) { this.mostrarMensaje("Seleccione una ficha valida para la Guagua caliente.", "error"); return; }
        if (!this.productoCaliente || !c.unidad || !(Number(c.monto) > 0)) return;
        const permitidos = ["efectivo", "tarjeta", "cheque", "transferencia"];
        const valores = permitidos.map(k => Number(this.pagos[k] || 0));
        const pagado = valores.reduce((a, b) => a + b, 0);
        if (valores.some(v => !Number.isFinite(v) || v < 0) || valores.filter(v => v > 0).length > 2
            || Math.round(pagado * 100) < Math.round(c.monto * 100)
            || Math.round((pagado - valores[0]) * 100) > Math.round(c.monto * 100)) {
          this.mostrarMensaje("Indique una o dos formas de pago que cubran el total. La devuelta solo aplica al efectivo.", "error"); return;
        }
        c.solicitud = { solicitudId: nuevoIdSolicitud(), cajaId: Number(this.contexto.cajaId || this.contexto.caja),
          turnoId: this.turno.id ? Number(this.turno.id) : null, numeroViaje: this.viajeCaliente, ficha: String(c.unidad.ficha),
          vehiculoId: Number(c.unidad.id),
          productoId: Number(c.productoId), monto: Number(c.monto), pagosPantalla: { ...this.pagos } };
        permitidos.forEach(k => { c.solicitud[k] = Number(this.pagos[k] || 0); });
      }
      try { this.persistirCaliente(); }
      catch (_) {
        c.solicitud = null;
        this.mostrarMensaje("No se pudo conservar la solicitud en el navegador. Habilite el almacenamiento antes de facturar.", "error"); return;
      }
      this.guardando = true;
      let confirmada = false, payload = null;
      try {
        const r = await this.$axios.post(this.$hostname + this.$hName + "/transportepv/calientes", c.solicitud,
          { headers: this.headers(), timeout: 120000 });
        const data = r.data || {}, pk = data.facturaVenta && data.facturaVenta.facturasventaPK;
        if (data.estatus !== "ok" || !pk || !pk.documento || !pk.secuencia) throw new Error("Respuesta de factura invalida.");
        confirmada = true;
        payload = { operacion: "guagua-caliente", documento: pk.documento, referencia: String(pk.secuencia),
          accion: c.enviarDirecto ? "print" : "preview" };
        this.ultimaCaliente = payload;
        this.limpiarCalienteConfirmada();
        // Only a retry of a previously issued fiscal invoice can need this legacy path.
        if (data.facturacionElectronica && data.facturacionElectronica.habilitada
            && !await this.procesarFacturacionElectronicaSiAplica(data)) {
          this.mostrarMensaje(data.ecfMensaje || "Factura guardada. Consulte Comprobantes e-CF antes de imprimir.", "warning"); return;
        }
        await this.enviarImpresionPreparada(payload);
        this.mostrarMensaje("Factura Guagua caliente guardada: " + pk.documento + "-" + pk.secuencia, "ok");
      } catch (error) {
        if (confirmada) {
          this.mostrarErrorImpresion("Factura caliente guardada", error,
            this.crearReimpresionPendiente("caliente", payload.documento + "-" + payload.referencia, payload));
        } else {
          const status = error.response && error.response.status;
          // Validation failures roll back the API transaction; timeouts/500 remain uncertain.
          if ((status === 400 || status === 409) && !/solicitud.*(utilizada|mas de una)/i.test(textoError(error))) {
            sessionStorage.removeItem(this.claveCaliente()); c.solicitud = null;
            this.mostrarMensaje(textoError(error), "error");
          } else this.mostrarMensaje("No se pudo confirmar la factura. Pulse FIN para reintentar la misma solicitud, sin cambiar los datos.", "warning");
        }
      } finally { this.guardando = false; }
    },
    async imprimirCalienteDirecto(payload) {
      const r = await this.$axios.get(this.$hostname + this.$hName + "/transportepv/calientes/" + payload.documento + "/" + payload.referencia + "/impresion",
        { headers: this.headers(), timeout: 30000 });
      const impresion = this.prepararOperacionImpresion({ accion: "print", formato: "TicketViaje",
        impresora: this.impresoraSeleccionada() || "", copias: 0, copiasPequeno: 0,
        imprimirPequeno: false, imprimirMaletas: false, boletos: [r.data] }, "boleto-transporte");
      await this.postImpresoraLocal("/impresora/imprimir", impresion);
    },
    reimprimirUltimaCaliente() {
      if (!this.ultimaCaliente || this.guardando) return;
      this.reimpresionPendiente = this.crearReimpresionPendiente("caliente", this.ultimaCaliente.documento + "-" + this.ultimaCaliente.referencia,
        { ...this.ultimaCaliente });
      return this.reimprimirPendiente();
    },
  },
};
